/* @flow */
/**
 * Created by dv on 9/25/2017.
 */
import {
  CollectionUserEntry,
  EditZmCollectionUserPermissionMessage,
  EditZmCollectionUserPermissionQuery
} from "../../../autogenerated/ZoomBridge";


export default class EditZmCollectionUserPermission {
  collectionId: number;
  user: CollectionUserEntry;

  constructor(collectionId: number, user: CollectionUserEntry) {
    this.collectionId = collectionId;
    this.user = user;
  }
  
  run(): Promise<boolean> {
    const message: EditZmCollectionUserPermissionMessage = new EditZmCollectionUserPermissionMessage();
    message.setCollectionId(this.collectionId).setCollectionUserEntry(this.user);
    const query: EditZmCollectionUserPermissionQuery = new EditZmCollectionUserPermissionQuery();
    query.message = message;
    return query.run(true);
  }
}
